import script from "./btn-audio.vue?vue&type=script&setup=true&lang=ts"
export * from "./btn-audio.vue?vue&type=script&setup=true&lang=ts"

import "./btn-audio.vue?vue&type=style&index=0&id=aed815ae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aed815ae"]])

export default __exports__